<template>
  <el-form>
    <el-form-item label="原生计划投放">
      <div class="native-switch">
        <el-switch v-model="form.enable" @change="onSwitchChange"></el-switch>
        <span style="font-size: 12px">&ensp;开启后，能使用原生投放样式，突破流量限制，额外获得优质原生流量。</span>
      </div>
    </el-form-item>

    <template v-if="form.enable">
      <el-form-item label="授权类型">
        <el-radio-group v-model="form.kol_user_type" @change="getNativeInfo">
          <el-radio-button :label="2">服务号授权</el-radio-button>
          <el-radio-button :label="1">个人号授权</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="计划头像与昵称">
        <div class="native-avatar">
          <el-select v-model="form.nativeId" :popper-append-to-body="false" placeholder="" @change="onAvatarChange">
            <el-option
              v-for="item in nativeUserList"
              :key="item.user_id"
              :label="item.user_name.concat('ID：' + item.user_id)"
              :value="item.user_id"
            >
              <div class="el-option-slot">
                <span>
                  <el-avatar size="small" :src="item.head_url"></el-avatar>
                </span>
                <span style="margin-left: 5px">{{ item.user_name }}</span>
                <span style="margin-left: 5px">ID：{{ item.user_id }}</span>
              </div>
            </el-option>
          </el-select>
        </div>
      </el-form-item>
    </template>
  </el-form>
</template>
<script>
import { getKuaiShouNativeUserList } from '@/api/kuaishou.local.model'

export default {
  props: ['form'],
  data() {
    return {
      nativeUserList: []
    }
  },
  methods: {
    onSwitchChange(v) {
      if (v) {
        this.getNativeInfo(2)
      }
    },
    onAvatarChange(v) {
      // 显示原生广告头像名称
      const name = this.nativeUserList.find((item) => item.user_id === v).user_name
      this.form.name = name
    },
    /**
     * @description: 根据账号id获取当前授权类型支持情况，目前普通快手号需要白名单支持
     */
    getNativeInfo(kol_user_type) {
      getKuaiShouNativeUserList({ kol_user_type, adAccountId: this.form.adId }).then((data) => {
        if (!data) {
          this.form.nativeId = ''
          this.form.name = ''
          this.nativeUserList = []
        } else {
          this.nativeUserList = data?.user_list || []
          // 获得数据后，默认选中第一个;
          const [firstItem] = this.nativeUserList
          const nativeId = firstItem?.user_id || ''
          this.form.nativeId = nativeId
          this.form.name = firstItem?.user_name || ''
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped></style>
